import { Box, Tooltip } from "@mui/material";
import { ReactElement } from "react";
import { useRecordContext } from "react-admin";

interface TruncatedFieldWrapperProps {
  children: ReactElement;
  maxWidth?: string | number;
  source?: string;
  tooltipDelay?: number; // in milliseconds
}

export const TruncatedFieldWrapper = ({
  children,
  maxWidth = "100px",
  source,
  tooltipDelay = 500, // default 500ms delay
}: TruncatedFieldWrapperProps) => {
  const record = useRecordContext();

  // Get the value to display in tooltip
  const value = source && record ? record[source] : "";
  const displayValue = value?.toString() || "";

  return (
    <Tooltip title={displayValue} arrow enterDelay={tooltipDelay}>
      <Box
        sx={{
          maxWidth,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        data-source={source}
      >
        {children}
      </Box>
    </Tooltip>
  );
};
